import React from 'react';

// @ts-ignore
import Social from '@r1-frontend/ui-react/components/buttons/social';

import { clearHTMLTags, clearNbsp } from '~/src/helpers/string';

import * as ST from './styled';

export interface IProps {
    title?: string,
    text?: string,
}

export const KnowledgebaseLayout: React.FC<IProps> = ({ children, title, text }) => {
    const getShareText = (service: string, title?: string, description?: string) => {
        const url = window.location.href;
        const str =
            `https://share.yandex.net/go.xml?service=${service}&url=${url}&title=${title}&description=${description}', '_blank', 'location=yes,height=570,width=520,scrollbars=yes,status=yes`;
        window.open(str);
    };

    const DESCRIPTION_LENGTH = 140;

    const getSocialConfig = (title: string, text: string) => {

        // TODO: Fix later in https://ticket.ertelecom.ru/browse/WEB-43177
        const description = clearNbsp(clearHTMLTags(text))
            .substr(0, DESCRIPTION_LENGTH) + '...';

        return (
            {
                vk: {
                    click: () => getShareText('vkontakte', title, description),
                },
                odn: {
                    click: () => getShareText('odnoklassniki', title, description),
                },
            }
        );
    };

    return (
        <ST.KnowledgebaseLayout>
            <ST.Content>
                {children}
                { title && text &&
                    <>
                        <ST.Text>Поделиться:</ST.Text>
                        <ST.Links>
                            <Social socials={getSocialConfig(title, text)} />
                        </ST.Links>
                    </>
                }
            </ST.Content>
        </ST.KnowledgebaseLayout>
    );
};
